import { connect } from 'react-redux';

import { highlightRoom, unhighlightRoom } from 'ha/pages/Search/actions';
import trackSearchResults from 'ha/pages/Search/actions/trackSearchResults';
import SearchResults from 'ha/pages/Search/components/SearchResults';
import {
  getListings,
  hasCitiesNearby,
  getCityCanonical,
  getCountryCanonical,
  getCityName,
  getCountryName,
  getCountryCode,
} from 'ha/pages/Search/selectors';
import { GlobalState } from 'ha/types/store';

export default connect(
  (state: GlobalState) => ({
    items: getListings(state),
    cityCanonical: getCityCanonical(state),
    countryCanonical: getCountryCanonical(state),
    countryCode: getCountryCode(state),
    shouldShowCitiesNearby: hasCitiesNearby(state),
    cityLocalizedName: getCityName(state),
    countryLocalizedName: getCountryName(state),
  }),
  {
    onHighlight: highlightRoom,
    onUnhighlight: unhighlightRoom,
    trackSearchResults,
  },
)(SearchResults);
